import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import { Milestone } from "../../interfaces/question";
import { answersBulkSave, getMilestonesToEdit } from "../../services/questions";

interface PropsI {
    onClose: () => void,
    lang: string
}

const TRANSLATES = {
    es:{
        yes:"si",
        no: "no",
        close: "cerrar"
    },
    pt:{
        yes: 'sim',
        no: 'não',
        close: 'fechar'
    }
}

const AnswerInModal = ({onClose, lang}:PropsI) => {

    const { change_answers_url } = useSelector((state: any) => state.milestones);
    const [milestones, setMilestones] = useState<Milestone[]>([]);
    const [loading, setLoading] = useState(true);
    const [session, setSession] = useState("");
    const [text, setText] = useState<any>({});

    useEffect(() => {
        if(lang === 'es'){
            setText(TRANSLATES.es);
        }

        if(lang === 'pt'){
            setText(TRANSLATES.pt);
        }
    },[lang])

    useEffect(() => {
        getMilestonesToEdit(change_answers_url)
        .then( (resp:any) => {
            setMilestones(resp.milestones);
            setSession(resp.session);
            setLoading(false);
        })
        .catch(err => console.log(err))

    },[change_answers_url])

    const handleAnswerClick = async (item:Milestone, answer: string) => {
        try{
            const updateItems = milestones.map((milestone:Milestone) => item.milestone_config === milestone.milestone_config ? {...milestone, answer, hasChange: true} : milestone);

            const selectedOnlyHasChanged = updateItems.filter((item: any) => item.hasChange);

            const payload = {
                session,
                answers: selectedOnlyHasChanged.map((item:Milestone) => ({ milestone_config: item.milestone_config, value: item.answer}))
            }
            setMilestones(updateItems);
            await answersBulkSave(payload);
        } catch(err){
            console.log(err);
        }
    }

    if(loading){
        return <Loader />
    }

    return (
        <>
            <div className="text-right">
                <button className="btn btn-outline-primary mb-3 custom-font" type="button"
                onClick={onClose}
                style={{borderRadius: '50px'}}>{text.close}</button>
            </div>

            <div style={{maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden'}}>
                {milestones.map((item:any)=> (
                    <div key={item.milestone_config}>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <p className="small">
                                {item.question}
                                </p>
                            </div>
                            <div className="col-sm-4">
                                <div className="d-flex">
                                    <button  className={`btn btn-outline-success buttons ${item.answer === 'done' && 'active'}`}
                                    onClick={() => handleAnswerClick(item, 'done')}>{text.yes}</button>
                                    <button className={`btn btn-outline-danger ml-2 buttons ${item.answer === 'failed' && 'active'}`}
                                    onClick={() => handleAnswerClick(item, 'failed')}>{text.no}</button>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>
                ))}
            </div>
        </>
    )
}

export default AnswerInModal
